import React, { useState, useEffect } from 'react'
import { Input, Button, Table, message } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { listPlayer, delPlayer } from '../../../http/modules/organization'
import XiuGai from './xiuGai'
import { useNavigate } from "react-router-dom";
const { Search } = Input;

export default function PersonnelList() {

  const navigate = useNavigate();

  const [selectionType, setSelectionType] = useState('checkbox');
  // 参赛老师
  const [playerlist, setPlayerlist] = useState()
  // 参赛老师id
  const [playerId, setPlayerId] = useState()
  // 选中的 id
  const [arrId, setArrID] = useState()

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setArrID(selectedRowKeys)
      // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === 'Disabled User',
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  //参赛者列表
  const OnListPlayer = async () => {
    const res = await listPlayer({
      "pageNo": 1,
      "pageSize": 10000,
    })
    let arr = []
    res.data?.list.map((item) => {
      arr.push(
        {
          key: item.uuid,
          name: item.name,
          phone: item.phone,
          orgName: item.orgName,
          work: item.work,
          title: item.title,
          intro: item.intro,
        },
      )
    })
    setPlayerlist(arr)
  }

   // 搜索按钮
   const onSearch = async(value) => {
    const res = await listPlayer({
      "pageNo": 1,
      "pageSize": 10000,
      "playerName":value
    })
      if(res.code==0){
      let arr = []
      res.data?.list.map((item) => {
        arr.push(
          {
            key: item.uuid,
            name: item.name,
            phone: item.phone,
            orgName: item.orgName,
            work: item.work,
            title: item.title,
            intro: item.intro,
          },
        )
      })
      setPlayerlist(arr)
    }else{
    }
  }

  // 删除参赛者
  const remove = async () => {
    if(!arrId){
      message.error('请先选择')
      return
    }
    const res = await delPlayer({
      playerUUIDList: arrId
    })
    if (res.code == 0) {
      message.success('删除成功')
      OnListPlayer()
    } else {
      message.error('删除失败')
    }
  }

  const columns = [
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
      className:'table'
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      key: 'phone',
      className:'table'
    },
    {
      title: '机构名称',
      dataIndex: 'orgName',
      key: 'orgName',
      className:'table'
    },
    {
      title: '职务',
      dataIndex: 'work',
      key: 'work',
      className:'table'
    },
    {
      title: '职称',
      dataIndex: 'title',
      key: 'title',
      className:'table'
    },
    {
      title: '授课人/团队简介',
      dataIndex: 'intro',
      key: 'intro',
      className:'table',
      ellipsis: true,
    },
    {
      title: '操作',
      dataIndex: '',
      key: '',
      className:'table',
      render: (event) => (
        <span style={{ color: '#1F78FE',cursor:'pointer' }} onClick={() => setPlayerId(event.key)}>
          修改
        </span>
      )
    }
  ];

  useEffect(() => {
    OnListPlayer()
  }, [])


  return (
    <>
      {playerId ? <XiuGai playerUUID={playerId} setPlayerId={setPlayerId} OnListPlayer={OnListPlayer}/> :
        <div div className='personnelList'>
          <header>
            <Search
              placeholder="请输入老师名字"
              allowClear
              enterButton="搜索"
              size="large"
              onSearch={onSearch}
            />
            <div className='headerButton'>
              <Button onClick={remove} shape="round" icon={<DeleteOutlined />} size={'large'}>
                删除
              </Button>
              <Button onClick={()=>navigate('/organization/personnelAdd')} style={{ marginLeft: '20px' }} type="primary" shape="round" icon={<PlusOutlined />} size={'large'}>
                新建
              </Button>
            </div>
          </header>
          <main>
            <Table rowSelection={{
              type: selectionType,
              ...rowSelection,
            }} dataSource={playerlist} columns={columns} />;
          </main>
        </div>
      }
    </>
  )
}
